export default __webpack_public_path__ + "static/media/ashley.d3c3cfd8.jpg";